import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetCurrency = () =>
  useMutation({
    mutationFn: () => client(`lookups/currencies`),
  });

export const useLookupDenominations = () =>
  useMutation({
    mutationFn: (data) => client(`lookups/currency/denominations/${data}`),
  });
export const useGetCurrencyList = () =>
  useMutation({
    mutationFn: (data) => client(`resources/currencies`, { data }),
  });
export const useGetCurrencyDetails = () =>
  useMutation({
    mutationFn: (data) => client(`resources/currencies/${data}`),
  });
export const useAddCurrency = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/currencies/add`, {
        data,
        successMessage: "Currency has been added successfully",
      }),
  });
export const useEditCurrency = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/currencies/edit`, {
        data,
        successMessage: "Currency has been updated successfully",
      }),
  });
